import React, { Component } from 'react';
import Wrp from "../../../../hoc/Wrp/Wrp";
import convertToHtml from './convertDraftjsToHtml';
import { UncontrolledTooltip } from 'reactstrap';
import { v4 as uuidv4 } from 'uuid'; 



class HeaderLabel extends Component {

  render() {
    const { label, isToolTip, helpText, className, sectionType, item,isPopupWindow } = this.props;
    
    if(label.entityMap==null){
      label.entityMap = {};
    }
    let classNameArr = [''];
    if(isPopupWindow===false){
      classNameArr.push(className);
    }
    // console.log(item);
    // if(item.quickCreateFrom!==undefined && item.quickCreateFrom===true){
    //   classNameArr.push('text-right');
    // }
    const text = convertToHtml(label);
    const tooltipId = uuidv4();
    return (
      <Wrp>
        {(sectionType!=='subform' || (item.label && item.label!=='')) ? 
          <div className={(classNameArr).join(' ')} style={{"position":"relative"}}> 
            <label className="text-truncate" title={text}> 
              {text}
            </label>
            {(isToolTip==true)?
              <Wrp>
                <a className="tooltipIcon"><span href="#" id={'toolTip'+tooltipId}><i className="fas fa-info-circle fa-lg"></i></span></a>
                <UncontrolledTooltip placement="top" target={'toolTip'+tooltipId}>
                  {helpText}
                </UncontrolledTooltip>
              </Wrp>
            :''}
          </div>
        :''}   
      </Wrp>
    );
  }
}

HeaderLabel.defaultProps = {
  className:"col-lg-3 col-md-3 col-sm-4"
}

export default HeaderLabel;